var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.56,
    height: 16.17,
    viewBox: "0 0 21.56 16.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Hide",
    d: "M13.456,24.266l1.225-1.225a4.028,4.028,0,0,1-4.944,4.944l1.225-1.225a2.683,2.683,0,0,0,2.5-2.5Zm8.018-.509A14.111,14.111,0,0,0,17.919,19.8l-.98.98a13.484,13.484,0,0,1,3.155,3.3c-.8,1.216-3.931,5.389-9.313,5.389a9.9,9.9,0,0,1-2.264-.268L7.409,30.314a11.412,11.412,0,0,0,3.371.508c7.053,0,10.55-6.149,10.695-6.41a.673.673,0,0,0,0-.655ZM18.667,17.15,3.845,31.972a.674.674,0,1,1-.953-.953l1.886-1.886A14.137,14.137,0,0,1,.085,24.412a.674.674,0,0,1,0-.655c.145-.261,3.642-6.41,10.695-6.41a11.345,11.345,0,0,1,4.754,1.031L17.715,16.2a.674.674,0,1,1,.953.953ZM5.783,28.129l1.706-1.706a4.036,4.036,0,0,1,5.63-5.63L14.5,19.414a9.92,9.92,0,0,0-3.718-.719c-5.382,0-8.515,4.173-9.313,5.389a13.228,13.228,0,0,0,4.316,4.045Zm2.684-2.684,3.673-3.673a2.665,2.665,0,0,0-1.36-.382,2.7,2.7,0,0,0-2.695,2.695,2.665,2.665,0,0,0,.382,1.36Z",
    transform: "translate(0 -16)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hidePassword_icon.8f1995e7d55f8b2e56fab0180c0f565c.svg";
export { ForwardRef as ReactComponent };